<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content"
                         style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal"
                               v-text="'Additional Informations'"></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg"
                                     alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content"
                                 style="overflow: visible">
                                <div class="row mt-2 pl-2 pr-2">
                                    <div class="col-md-12" v-for="item in items" v-bind:key="item.id">
                                        <TextField
                                            v-model="item.answer"
                                            :name="'question_' + item.question_id"
                                            :label="item.question_text"
                                            rows="5"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3">
                                <div class="d-flex justify-content-center">
                                    <button v-text="'Close'"
                                            class="btn-dialog btn-sm ok-btn"
                                            @click="closeModal">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextField from "@/commons/FormElements/TextField.vue";

export default {
    name: "ModalCampaignManualDonationQuestions",
    components: {TextField},
    props: {
        questions: Array
    },
    data() {
        return {
            items: []
        }
    },
    watch: {
        items(val) {
            console.log(val);
        }
    },
    created() {
        this.items = this.questions.map((item) => {
            return {
                question_id: item.question_id,
                question_text: item.question_text,
                answer: item.answer
            }
        });
    },
    methods: {
        closeModal() {
            this.$emit("close", this.items);
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}
</style>
